import thumbnail from "../../../assets/images/projects/traveloka-flexible-discovery/hero-phones.png";
import { ProjectDataProps } from "../props";

export default {
  title: "Open Search for Flexible Travelers",
  description:
    "Helping travelers discover where and when to go before their trip is fixed.",
  image: thumbnail,
  path: "/traveloka-flexible-discovery",
  thumbnailBackground: "linear-gradient(145deg, #dff4ff 0%, #b9e5fa 100%)",
  thumbnailFit: "contain",
  thumbnailPosition: "center",
  thumbnailScale: 1.08,
} as ProjectDataProps;
